export const AGENT_ROLE_COLORS: Record<string, string> = {
  orchestrator: '#1E3A5F',
  planner: '#3B82F6',
  researcher: '#8B5CF6',
  writer: '#10B981',
  critic: '#F59E0B',
  refiner: '#00C896',
  brand_guard: '#EF4444',
  image_prompter: '#EC4899',
  validator: '#6366F1',
  analyst: '#14B8A6',
  optimizer: '#F97316',
}

export const STATUS_COLORS = {
  success: { border: '#10B981', bg: '#F0FDF4', text: '#065F46' },
  error: { border: '#EF4444', bg: '#FEF2F2', text: '#991B1B' },
  running: { border: '#3B82F6', bg: '#EFF6FF', text: '#1E40AF' },
  pending: { border: '#CBD5E1', bg: '#F8FAFC', text: '#64748B' },
}

export const TEAM_COLORS = {
  content: '#3B82F6',
  visual: '#EC4899',
  strategy: '#8B5CF6',
  orchestrator: '#1E3A5F',
}
